import React, { useEffect, useState, useRef } from 'react';
import { getURL, postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';
import { useParams } from 'react-router-dom';
import InputHandler from '../../UIComponents/InputHandler';

export default function LinkVerification() {
    const {otp} = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [countDown, setCountDown] = useState(60);
    const [storeData, setStoreData] = useState({});
    const [formData, setFormData] = useState({});
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [OrganizationData, setOrganizationData] = useState({});
    const [API_URL, setAPIURL] = useState("");


    const fetchURL = async () => {
        const URL = await getURL();
        setAPIURL(URL);
    };

    const countdownStarted = useRef(false);
    const otpInputs = useRef([]);

    // Handles OTP input change and moves focus to the next input
    // const handleOTPChange = (e, index) => {
    //     const { value } = e.target;
    //     if (/^\d*$/.test(value) && value.length <= 1) {
    //         const newOTP = [...formData.otp];
    //         newOTP[index] = value;
    //         setFormData({ otp: newOTP });

    //         // Move focus to the next input if value is entered
    //         if (value && index < otpInputs.current.length - 1) {
    //             otpInputs.current[index + 1].focus();
    //         }
    //     }
    // };

    // Handles Backspace key to delete input and move focus to the previous field
    // const handleKeyDown = (e, index) => {
    //     if (e.key === 'Backspace' && !formData.otp[index]) {
    //         if (index > 0) {
    //             otpInputs.current[index - 1].focus();
    //         }
    //         const newOTP = [...formData.otp];
    //         newOTP[index] = '';
    //         setFormData({ otp: newOTP });
    //     }
    // };

    // Verify OTP submission
    const verifyOTP = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) {
        } else {
            const store_data = JSON.parse(store() || '{}');
            try {
                // const { org_id, username } = store_data;
                const filter = {
                    org_id: OrganizationData?.id,
                    username: formData?.username,
                    otp: otp,
                    action: 'set-password',
                };
                const response = await postAPI('/users/verifyOTP', filter);
                console.log(response);
                if (response?.status === 1) {
                    setIsBTNClicked(false);
                    setStore({ ...response.data, is_verified: 1, is_login_success: store_data?.submit?.action === 'ResetPassword' ? 0 : 1 });
                    setTimeout(() => {
                        window.location.href ='/Admin/SetPassword';
                            // store_data?.submit?.action === 'ResetPassword' ? '/Admin/SetPassword' : '/Admin/Dashboard';
                    }, 2000)
                } else {
                    setIsBTNClicked(false);
                    alert(response?.error);
                }
            } catch (e) {
                setIsBTNClicked(false);
                alert(e?.response?.data?.error);
                console.error('Exception Error:', e?.response?.data?.error);
            }
        }
    };

    // Resend OTP request
    const resendOTP = async () => {
        try {
            const store_data = JSON.parse(store() || '{}');
            const response = await postAPI(
                '/users/sendOTP',
                store_data?.submit
            );
            if (response?.status === 1) {
                resetCountDown();
            } else {
                alert(response?.error);
            }
        } catch (e) {
            alert(e?.response?.data?.error);
            console.error('Exception Error:', e?.response?.data?.error);
        }
    };

    // Reset countdown timer
    const resetCountDown = () => {
        if (countdownStarted.current) return;
        countdownStarted.current = true;
        setCountDown(60);

        const counterInterval = setInterval(() => {
            setCountDown((prev) => {
                if (prev > 1) {
                    return prev - 1;
                } else {
                    clearInterval(counterInterval);
                    countdownStarted.current = false;
                    return 0;
                }
            });
        }, 1000);
    };

    const fetchOrganizationData = async () => {
        try {
            const filter = { reg_domain: window?.location?.host }
            const response = await postAPI("/organization/fetchSingle", filter);
            setOrganizationData({
                ...OrganizationData,
                ...response?.data[0]
            })
        } catch (e) {
            console.log("Exception Error: ", e?.response?.data?.error)
        }
    }

    useEffect(() => {
        fetchOrganizationData();
        fetchURL();
        resetCountDown();
        const store_data = JSON.parse(store() || '{}');
        setStoreData(store_data);
    }, []);

    return (
        <div className="authentication-wrapper authentication-cover authentication-bg">
            <div className="authentication-inner row">
                <div className="d-none d-lg-flex col-lg-7 p-0">
                    <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
                        <img
                            src="../../theme/assets/img/illustrations/auth-two-step-illustration-light.png"
                            alt="auth-two-steps-cover"
                            className="img-fluid my-5 auth-illustration"
                        />
                    </div>
                </div>
                <div className="d-flex col-12 col-lg-5 align-items-center p-4 p-sm-5">
                    <div className="w-px-400 mx-auto">
                        <h3 className="mb-1 fw-bold">Verify Your Account 💬</h3>
                        <p className="text-start mb-4">Enter the username sent to email.</p>
                            <InputHandler form_data={formData} setFormData={setFormData} Name="username" Type="text" Label="Username" className="form-control" autoFocus={true} />
                        <div className="auth-input-wrapper d-flex justify-content-between">
                            {/* {formData.otp.map((_, i) => (
                                <input
                                    key={i}
                                    type="text"
                                    className="form-control auth-input text-center mx-1 my-2"
                                    maxLength="1"
                                    ref={(el) => (otpInputs.current[i] = el)}
                                    value={formData.otp[i]}
                                    onChange={(e) => handleOTPChange(e, i)}
                                    onKeyDown={(e) => handleKeyDown(e, i)}
                                />
                            ))} */}
                        </div>
                        <button className="btn btn-primary d-grid w-100 mb-3" onClick={verifyOTP}>
                        {IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Verify
                        </button>
                        {/* <p className="text-center">
                            {countDown === 0 ? (
                                <>
                                    Didn't get the code?{' '}
                                    <a href="#" onClick={resendOTP}>
                                        Resend
                                    </a>
                                </>
                            ) : (
                                `Wait for ${countDown}s to resend`
                            )}
                        </p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
